export const devLog = () => {};
export const EMPTY_OBJECT = Object.freeze({});
export const ACTUATED_JOINT_COLOR = 0xd97706;
export const ACTUATED_JOINT_LABEL_ICON_COLOR = "#d97706";
/** Connect-body equality body1 marker (teal-green). */
export const CONSTRAINT_CONNECT_BODY1_MARKER_COLOR = 0x00e5a0;
/** Connect-body equality body2 marker (yellow wireframe). */
export const CONSTRAINT_CONNECT_BODY2_MARKER_COLOR = 0xfacc15;
/** Connect-body equality line/label color. */
export const CONSTRAINT_CONNECT_MARKER_COLOR = CONSTRAINT_CONNECT_BODY1_MARKER_COLOR;
/** Weld-body equality markers (amber). */
export const CONSTRAINT_WELD_MARKER_COLOR = 0xffaa00;
/** Joint-joint equality markers (indigo — cooler than magenta so tendon roses/pinks read separately). */
export const CONSTRAINT_JOINT_EQ_MARKER_COLOR = 0x4f46e5;
/** Actuated tendon highlight — hues disjoint from constraint markers above. */
export const ACTUATED_TENDON_COLOR = 0xea580c;
export const EMPTY_BODY_SELECTION_HIGHLIGHT_RADIUS = 0.09;
export const SAVED_CAMERA_MARKERS_GROUP_NAME = "__savedCameraMarkers";
export const SAVED_LIGHT_MARKERS_GROUP_NAME = "__savedLightMarkers";
export const SCENE_LIGHT_OBJECTS_GROUP_NAME = "__sceneLightObjects";
export const DEBUG_LIBRARY_DROP = false;
/** Short tap on the 3D viewport (mobile) dismisses open UI; must match drag threshold loosely. */
export const MOBILE_VIEWPORT_BLANK_TAP_MAX_MS = 450;
export const MOBILE_VIEWPORT_BLANK_TAP_MAX_PX = 14;
export const TRACKPAD_WHEEL_DELTA_MAX_PX = 80;
export const TRACKPAD_WHEEL_SESSION_MS = 220;
export const debugLibraryDrop = (...args) => {
  if (DEBUG_LIBRARY_DROP) console.log("[LibraryDropDebug]", ...args);
};

export const LIBRARY_GRIPPER_ATTACH_MARKER_POOL = 16;
/** Default ring color matches `libraryDropShadow` outer ring (`0x22d3ee`). */
export const LIBRARY_GRIPPER_ATTACH_MARKER_COLOR = 0x22d3ee;
export const LIBRARY_GRIPPER_ATTACH_MARKER_HOVER_COLOR = 0xfacc15;
export const LIBRARY_GRIPPER_ATTACH_HALO_RADIUS = 0.28;

export const CONNECT_CONSTRAINT_GAP_VISIBLE_METERS = 0.002;
export const CONNECT_CONSTRAINT_GAP_WARN_METERS = 0.05;
export const CONSTRAINT_MARKER_REFERENCE_MODEL_DIMENSION = 1.0;
export const CONSTRAINT_MARKER_MIN_SCALE = 0.45;
export const CONSTRAINT_MARKER_MAX_SCALE = 1.0;
export const CONSTRAINT_MARKER_MIN_LINE_SCALE = 0.6;
export const CONSTRAINT_MARKER_RADIUS = 0.012;
export const CONSTRAINT_MARKER_RADIUS_LARGE = 0.016;
export const CONSTRAINT_MARKER_RADIUS_SMALL = 0.0085;
export const CONSTRAINT_MARKER_WELD_PICK_RADIUS = 0.022;
export const CONSTRAINT_MARKER_WELD_BOX_SIZE = 0.03;
export const CONSTRAINT_MARKER_DASHED_LINE_WIDTH = 2.5;
export const CONSTRAINT_MARKER_SOLID_LINE_WIDTH = 4;
export const CONSTRAINT_MARKER_JOINT_EQ_LINE_WIDTH = 3.5;
export const TENDON_VISUALIZATION_MARKER_RADIUS = 0.008;
export const TENDON_VISUALIZATION_LINE_WIDTH = 1;
export const TENDON_WRAP_GEOM_HIGHLIGHT_COLOR = 0x00ff66;
export const TENDON_MJCF_REFERENCE_WIDTH = 0.001;
